import React from 'react';
import RequestComponent from '../Other/RequestComponent';
import MarqueeText from '../Other/MarqueeText';

function ContactUs() {
    return (
        <div>
             <div class="common-hero" style={{width:'100%', backgroundSize:'cover'}}>
                <div class="container">
                    <div class="row align-items-center text-center">
                        <div class="col-lg-6 m-auto">
                            <div class="main-heading">
                                {/* <h1>About Us</h1>
                                <div class="space16"></div>
                                <span class="span"> <a href="/">Home</a> <span class="arrow"><i class="fa-regular fa-angle-right"></i></span> About Us</span> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <section class="hero10-benar">
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-12">
                            <MarqueeText/>
                        </div>
                    </div>

                    <div class="slider-after"></div>
                </div>
            </section>
            <div class="space100"></div>
            <div class="contact-page">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="contact-boxs">
                                <div class="heading1">
                                    <h2>Get in Touch with Us</h2>
                                    <div class="space16"></div>
                                    <p>We’re here to help! Whether you have questions, need expert advice, or want to discuss how our services can transform your business, feel free to reach out. Our team is ready and eager to assist you through the channel that works best for you.</p>
                                </div>
                                <div class="contact-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/contact-page-icon1.png" alt="" />
                                    </div>
                                    <div class="heading">
                                        <a href="tel:+919211047778" class="text">+91 9211047778</a>
                                    </div>
                                </div>

                                <div class="contact-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/contact-page-icon2.png" alt="" />
                                    </div>
                                    <div class="heading">
                                        <a href="mailto:info@m2v-consulting.com" class="text">info@m2v-consulting.com </a>
                                    </div>
                                </div>

                                <div class="contact-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/contact-page-icon3.png" alt="" />
                                    </div>
                                    <div class="heading">
                                        <a href="tel:(124)555-6565" class="text">T-3, 620, 6th Floor, Golden-I, Techzone - 4<br /> Greater Noida, West Gautam Budha Nagar, Uttar Pradesh- 201306 </a>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="contact-form-details">
                                <form action="#">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="single-input">
                                                <input type="text" placeholder="First Name" required/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="single-input">
                                                <input type="text" placeholder="Last Name" required/>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="single-input">
                                                <input type="email" placeholder="Email" required/>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="single-input">
                                                <input type="number" placeholder="Phone" required/>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="single-input">
                                                <input type="text" placeholder="Subject"required/>
                                            </div>
                                        </div>

                                        <div class="col-lg-12">
                                            <div class="single-input">
                                                <textarea cols="30" rows="5" placeholder="Message" required></textarea>
                                            </div>
                                        </div>

                                        <div class="col-lg-12">
                                            <button class="theme-btn1">Submit <span><i class="fa-solid fa-arrow-right"></i></span></button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="space100"></div>

            {/* <div class="contact-map-page">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d196064.65881483705!2d88.93201515862421!3d24.061083775097945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39febca82f6a21ed%3A0x4040980d7c6874f8!2sKushtia%20District!5e0!3m2!1sen!2sbd!4v1673751720794!5m2!1sen!2sbd" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div> */}
            {/* <RequestComponent/> */}
        </div>
    );
}

export default ContactUs;